import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isUrl } from 'sh-www/utils/misc';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { SIGNUP_STEP_WORK_SAMPLES } from 'sh-www/services/commands/user-commands';

/** @module */
class CreatorSignupWorkController extends Controller {
  @service('video-thumbnail-from-url')
  videoThumbnailService;

  @service('commands/user-commands')
  userCommandService;

  @service router;
  @service session;

  showProjectForm = false;
  projectToEdit = null;

  @action
  onEditProjectClicked(projectToEdit) {
    this.setProperties({ projectToEdit, showProjectForm: true });
  }

  @action
  toggleProjectForm(value) {
    this.set('showProjectForm', value);

    if (!value) {
      this.set('projectToEdit', null);
    }
  }

  /**
   * @param {DS.Model} digest
   * @returns {string}
   */
  @action
  getProjectDigestImage(digest) {
    const imgSrc = digest.thumbnailUrl;
    const digestLink = digest.link;

    if (imgSrc) return imgSrc;
    if (!digestLink || !isUrl(digestLink)) return '';

    return this.videoThumbnailService.getThumb(digestLink);
  }

  @action
  async updateUser() {
    // This is to account for whitelisted (i.e. invited) users who choose to skip adding
    // work samples. This is a noop for non-whitelisted users as the client-side validation
    // logic won't enable the submit button until the funnel requirements are met
    await this.userCommandService.markFunnelStepComplete(
      this.session.currentUser.id,
      SIGNUP_STEP_WORK_SAMPLES,
    );

    await this.session.loadCurrentUser();

    this.router.transitionTo(
      EMBER_ROUTE_NAMES.SIGNUP__STEP__DONE,
    );
  }
}

export default CreatorSignupWorkController;
